"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const Audiences_1 = require("../../../common/js/constants/Audiences");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const CONTEXT_TOKEN_HEADER = 'sw-context-token';
const USER_ACCESS_TOKEN_HEADER = 'user-access-token';
class ShopAuthorizationMiddleware {
    previousPortalToken = null;
    post(context) {
        return Promise.resolve(context.response);
    }
    pre(context) {
        const { url, init } = context;
        const fetchParams = { url, init };
        const headers = new Headers(fetchParams.init.headers);
        headers.delete(CONTEXT_TOKEN_HEADER);
        headers.delete(USER_ACCESS_TOKEN_HEADER);
        return Promise.resolve()
            .then(() => {
            if (!AuthorizationStore_1.default.auth0?.isAuthenticated) {
                return;
            }
            return AuthorizationStore_1.default.auth0.getAccessTokenSilently().then((token) => {
                const scopes = ['email', 'offline_access'].concat(AuthorizationStore_1.default.scopes);
                const options = {
                    audience: Audiences_1.Audiences.SHOP,
                    ignoreCache: this.getPreviousPortalToken() !== token,
                    scope: scopes.join(' '),
                };
                return AuthorizationStore_1.default.auth0?.getAccessTokenSilently(options).then((accessToken) => {
                    this.setPreviousPortalToken(token);
                    headers.set(USER_ACCESS_TOKEN_HEADER, accessToken);
                });
            });
        })
            .then(() => {
            fetchParams.init.headers = headers;
            return fetchParams;
        });
    }
    setPreviousPortalToken(token) {
        this.previousPortalToken = token;
    }
    getPreviousPortalToken() {
        return this.previousPortalToken;
    }
}
__decorate([
    bind_decorator_1.default
], ShopAuthorizationMiddleware.prototype, "setPreviousPortalToken", null);
__decorate([
    bind_decorator_1.default
], ShopAuthorizationMiddleware.prototype, "getPreviousPortalToken", null);
exports.default = new ShopAuthorizationMiddleware();
